<template>
<div>
    <div class="title">产品中心<span></span></div>
    <div class="xiang11">
        <div class="xiang22">
          <div><img width="100%" height="100%" :src="chanx.imgpath!=undefined?`http://upload.lusenky.com/upload/good/${chanx.imgpath}`:''" alt=""></div>
          <div class="xiang33">
              <p>{{chanx.name}}</p>
              <p v-html="chanx.modName">{{chanx.modName}}</p>
              <div>
                  <a href="#">立即咨询</a><span>订购热线：13366936909</span>
              </div>
          </div>
        </div>
        <p>产品详情</p>
        <div>
            <img style="max-width:900px;" :src="chanx.jsimg!=undefined?`http://upload.lusenky.com/upload/detailed/${chanx.jsimg}`:''" alt="">
            <p>{{chanx.content}}</p>
        </div>
    </div>
</div>
</template>
<script>
export default {
    data(){
        return{
           chanx:[]
        }
    },
    methods:{
      getid(){
        let id=this.$route.query.id
        if(id){
          this.axios.get('goods/by?id='+this.$route.query.id).then((res)=>{this.chanx=res.data;});
        }
      }
    },
    created(){
        this.getid()
    }
}
</script>
<style scoped>
    .title{
        width: 148px;
        height: 45px;
        background: rgba(230,0,18,1);
        color: #fff;
        font-size: 24px;
        text-align: left;
        line-height: 45px;
        padding-left: 29px;
        font-weight: bold;
        position: relative;
    }
    .title>span{
        display: inline-block;
        width: 70px;
        height: 45px;
        background: #fff;
        right: -53px;
        border-bottom:3px solid rgba(230,0,18,1);
        position: absolute;
        -webkit-transform: skewX(45deg);
        transform: skewX(37deg);
    }
.xiang11{
    padding: 20px 15px;
    border-top: 3px solid rgba(230,0,18,1);
    background:#ededed;
}
.xiang22{
  display: flex;
  justify-content: space-between;
}
.xiang22>div:first-child{
    width: 250px;
    height: 250px;
}
.xiang22>div:last-child{
width: 640px;
position: relative;
}
.xiang33>p+p{
 margin-top: 20px;
}
.xiang33>p:first-child{
    font-size: 17px;
    font-weight: 800;
}
.xiang33>div>a{
    position: absolute;
    bottom: 0px;
    background: red;
    color:white;
    font-size: 14px;
    padding: 5px 20px;
    border-radius: 5px;
}
.xiang33>div>span{
    position: absolute;
    bottom: 0px;
    left: 140px;
    color: red;
    padding: 5px 20px;
    border: 1px solid red;
    font-size: 14px;
     border-radius: 5px;
}
.xiang11>p{
    margin:35px 0;
    margin: 35px 0;
    padding-left: 12px;
    font-weight: 800;
    border-left: 8px solid red;
}
</style>